import axios from 'axios'

import { API_URL } from '../constants/constants'

// Create axios instance with base configuration
export const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Export the configured instance
export { axiosInstance as axios }
